import { MacroStep } from "@src/Steps/step/Steps";
import "./topbar.scss";
import { environment } from "@src/MarqueBlanche";

export type TopBarProps = {
  activeMacroStep: MacroStep;
};

const getTopbarContratInfoDiv = () => {
  return (
    <div className="topbar__contract-infos">
      <img src="/logo-paxi.png" alt="logo-sage" />
      <div>
        <p>Contrat Paxivie</p>
      </div>
    </div>
  );
};

export function TopBar({ activeMacroStep }: TopBarProps) {
  return (
    <div className="topbar">
      <div className="topbar__logo">
        {environment.is.default && (
          <img src="/logo-tutelaire.png" alt="logo-tutelaire" />
        )}
      </div>
      <div className="topbar__progress">
        <p
          className="topbar__progress-item"
          data-active={activeMacroStep === MacroStep.Simulate}
        >
          <span>01</span> Obtenir mon tarif
        </p>
        <span className="topbar__progress-line" />
        <p
          className="topbar__progress-item"
          data-active={activeMacroStep === MacroStep.Receive}
        >
          <span>02</span> Recevoir mon devis
        </p>
        <span className="topbar__progress-line" />

        <p
          className="topbar__progress-item"
          data-active={activeMacroStep === MacroStep.Subscribe}
        >
          <span>03</span> Souscrire en ligne
        </p>
      </div>
      {getTopbarContratInfoDiv()}
    </div>
  );
}
